import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useMyTeam } from '../../team/useMyTeam';
import type { Team } from '../../../types/team';
import PlaybookShell from './PlaybookShell';
import styles from './author.module.css';

type Props = {
  crumb: string;
  wide?: boolean;
  children: (team: Team) => ReactNode;
};

export default function AuthorGate({ crumb, wide = false, children }: Props) {
  const { user } = useAuth();
  const { team, loading, error } = useMyTeam(user?.id);

  if (loading) {
    return <PlaybookShell crumb={crumb} wide={wide}><p className={styles.status}>Loading your team…</p></PlaybookShell>;
  }
  if (error) {
    return <PlaybookShell crumb={crumb} wide={wide}><p className={styles.error}>{error.message}</p></PlaybookShell>;
  }
  if (!team) {
    return <PlaybookShell crumb={crumb} wide={wide}><p className={styles.status}>Join a team before editing the playbook.</p></PlaybookShell>;
  }
  if (team.role !== 'strategist') {
    return (
      <PlaybookShell crumb={crumb} wide={wide}>
        <div className={styles.blocked}>
          <h1>Strategists only</h1>
          <p>Only a strategist can add or edit strategies and lineups.</p>
          <Link to="/strategies">Back to strategies</Link>
        </div>
      </PlaybookShell>
    );
  }
  return <PlaybookShell crumb={crumb} wide={wide}>{children(team)}</PlaybookShell>;
}
